import { type CubicBezier, type Point, type Arc, type QuadraticBezier } from 'wilderness-dom-node';

export function isArc(point: Point): point is Arc {
  return 'curve' in point && point.curve.type === SVG_CURVE_TYPES.ARC;
}

export function isQuadraticBezier(point: Point): point is QuadraticBezier {
  return 'curve' in point && point.curve.type === SVG_CURVE_TYPES.QUADRATIC;
}

export function isCubicBezier(point: Point): point is CubicBezier {
  return 'curve' in point && point.curve.type === SVG_CURVE_TYPES.CUBIC;
}

export const SVG_CURVE_TYPES = {
  CUBIC: 'cubic',
  QUADRATIC: 'quadratic',
  ARC: 'arc'
};
